import { Injectable } from "@angular/core";
import {
  HttpHeaders,
  HttpErrorResponse,
  HttpEventType,
} from "@angular/common/http";
import {
  Tenant,
  CensusLiteMethod,
  NQSPlanApiMethod,
  UserApiMethod,
  ValidationMessage,
  RateTableAPIMethod,
  PlanLiteMethod,
} from "../constant";
import { environment } from "../../../environments/environment";
import {
  Observable,
  throwError,
  Observer,
  forkJoin,
  BehaviorSubject,
} from "rxjs";
import { HttpService } from "./http.service";
import { ActivatedRoute } from "@angular/router";
import { catchError } from "rxjs/operators";
import { AuthorizationService } from "../../authorization/authoriation.service";
import { MatLegacyDialog as MatDialog } from "@angular/material/legacy-dialog";
import { AlertPopupComponent } from "src/app/alert-popup/alert-popup.component";
import { RateTableRequest } from "src/app/model/rateTableRequest.model";
import { NgxSpinnerService } from "ngx-spinner";
import { saveAs } from "file-saver";
import { Download } from "src/app/model/download.model";
import { marketSegmentType } from "src/app/model/enums/market-segment.enum";
import { CarrierLogoRequest } from "src/app/model/carrier.model";

@Injectable({
  providedIn: "root",
})
export class DataService {
  public downloads: Download[];
  public generatingRateTable = false;

  private baseUrl = environment.apiEndPoints.ratesTableApiBaseUri;
  private planLiteApiBaseUrl = environment.apiEndPoints.planLiteApiBaseUri;
  private quoteLiteApiBaseUrl = environment.apiEndPoints.quoteLiteApiBaseUri;
  private censusLiteApiBaseUrl = environment.apiEndPoints.censusLiteApiBaseUri;
  private userApiBaseUrl = environment.apiEndPoints.userApiBaseUri;
  private nqsPlanApiUrl = environment.apiEndPoints.nqsPlanApiBaseUri;
  private wbQuoteUrl = environment.wbQuoteUri;
  private wbQuoteLiteUrl = environment.wbQuoteLiteUri;
  private nqsQuoteApiBaseUrl = environment.apiEndPoints.nqsQuoteApiBaseUri;
  private ratesTable = environment.redirectUri;
  private rateTableId = new BehaviorSubject<number>(0);
  public activateNetworkNav = new BehaviorSubject<boolean>(false);
  public IsTermsAccepted = false;
  changeRateTable = this.rateTableId.asObservable();
  public carrierIdChanges = this.activateNetworkNav.asObservable();
  nqsHttpOptions: any = {
    headers: new HttpHeaders({
      "Content-Type": "application/json",
      Tenant: Tenant.Name + "/" + Tenant.Id,
    }),
  };

  getdownloadHttpOptions() {
    return {
      observe: "events",
      responseType: "blob",
      reportProgress: true,
      headers: new HttpHeaders({
        "Cache-Control": "no-cache",
        Pragma: "no-cache",
        Authorization: `Bearer ${this.authService.authToken}`,
      }),
    };
  }

  constructor(
    private _httpService: HttpService,
    private route: ActivatedRoute,
    private authService: AuthorizationService,
    private dialog: MatDialog,
    private spinner: NgxSpinnerService
  ) {}

  geRateTableHttpOptions() {
    return {
      headers: new HttpHeaders({
        "Cache-Control": "no-cache",
        Pragma: "no-cache",
        "Content-Type": "application/json",
        Authorization: `Bearer ${this.authService.authToken}`,
      }),
    };
  }
  getQuoteLiteHttpOptions() {
    return {
      headers: new HttpHeaders({
        "Cache-Control": "no-cache",
        Pragma: "no-cache",
        "Content-Type": "application/json",
        Authorization: `Bearer ${this.authService.authToken}`,
      }),
    };
  }

  getGroupDetails(
    searchText: string,
    brokerId: number,
    marketSegmentId: any
  ): any {
    let groupDetailsUrl = `${environment.apiEndPoints.censusLiteApiBaseUri}${CensusLiteMethod.GroupDetails}`;
    groupDetailsUrl = groupDetailsUrl.replace(
      "{brokerId}",
      brokerId.toString()
    );
    groupDetailsUrl = groupDetailsUrl.replace(
      "{marketsegmentId}",
      marketSegmentId
    );
    return this._httpService
      .post<any>(
        groupDetailsUrl,
        JSON.stringify(searchText),
        this.getQuoteLiteHttpOptions()
      )
      .pipe(catchError((e: any) => this.handleError(e, this)));
  }

  getActiveCarriers(quotingContext) {
    let getCarriersUrl = `${environment.apiEndPoints.nqsPlanApiBaseUri}${NQSPlanApiMethod.GetActiveCarriers}`;
    return this._httpService.post<any>(
      getCarriersUrl,
      quotingContext,
      this.nqsHttpOptions
    );
  }

  getUserInformation(userId: number): any {
    let userBrokerAccountsUrl = `${this.userApiBaseUrl}${UserApiMethod.GetUserInformation}`;
    userBrokerAccountsUrl = userBrokerAccountsUrl.replace(
      "{userId}",
      userId.toString()
    );
    return this._httpService
      .get<any>(userBrokerAccountsUrl, this.getQuoteLiteHttpOptions())
      .pipe(catchError(this.handleError));
  }
  getSICCodes(searchText: string): any {
    let sicCodeUrl = `${this.censusLiteApiBaseUrl}${CensusLiteMethod.SICCode}${searchText}`;
    return this._httpService
      .get<any>(sicCodeUrl, this.getQuoteLiteHttpOptions())
      .pipe(catchError((e: any) => this.handleError(e, this)));
  }
  redirect(): any {
    window.open(this.getRedirectUrl(), "_self");
  }
  setLocalStorageItem(key: string, value: any) {
    window.localStorage.setItem(key, value);
  }
  clearLocalStorageItems(): any {
    window.localStorage.clear();
    sessionStorage.clear();
  }

  getAgencyDetails(brokerId: number): any {
    let agencyDetailsUrl = `${this.userApiBaseUrl}${UserApiMethod.GetBrokerAgencyDetails}`;
    agencyDetailsUrl = agencyDetailsUrl.replace(
      "{brokerId}",
      brokerId.toString()
    );
    return this._httpService
      .get<any>(agencyDetailsUrl, this.getQuoteLiteHttpOptions())
      .pipe(catchError((e: any) => this.handleError(e, this)));
  }
  getNetworkDetail(requestData): any {
    let getCarriersUrl = `${this.nqsPlanApiUrl}${NQSPlanApiMethod.GetNetworksLite}`;
    return this._httpService
      .post<any>(getCarriersUrl, requestData, this.nqsHttpOptions)
      .pipe(catchError((e: any) => this.handleError(e, this)));
  }
  getRedirectUrl(): string {
    var redirectUrl = this.wbQuoteLiteUrl;
    if (localStorage) {
      var storedRedirectUrl = localStorage.getItem("redirectUrl");
      var isFromWBQuote = localStorage.getItem("IsFromWBQuote");

      this.clearLocalStorageItems();
      if (
        storedRedirectUrl != null &&
        storedRedirectUrl != undefined &&
        storedRedirectUrl != ""
      ) {
        redirectUrl = storedRedirectUrl;
      }

      if (
        isFromWBQuote != null &&
        isFromWBQuote != undefined &&
        isFromWBQuote != ""
      ) {
        redirectUrl = this.wbQuoteUrl;
      }
    }
    return redirectUrl;
  }
  saveGroupDetails(groupDetails: any): any {
    let addGroupUrl = `${this.censusLiteApiBaseUrl}${CensusLiteMethod.AddGroup}`;
    return this._httpService
      .post<any>(addGroupUrl, groupDetails, this.getQuoteLiteHttpOptions())
      .pipe(catchError((e: any) => this.handleError(e, this)));
  }
  getPostalDetails(searchText: string): any {
    let postalDetailsUrl = `${this.censusLiteApiBaseUrl}${CensusLiteMethod.PostalDetails}${searchText}`;

    return this._httpService
      .get<any>(postalDetailsUrl, this.getQuoteLiteHttpOptions())
      .pipe(catchError((e: any) => this.handleError(e, this)));
  }
  getRateTableDatabyId(Id: number): any {
    let rateTableUrl = `${this.baseUrl}${RateTableAPIMethod.getRateTableById}`;
    rateTableUrl = rateTableUrl.replace("{Id}", Id.toString());
    return this._httpService
      .get(rateTableUrl, this.geRateTableHttpOptions())
      .pipe(catchError((e: any) => this.handleError(e, this)));
  }
  saveRateTableInfo(rateTableRequest: RateTableRequest): any {
    let rateTableUrl = `${this.baseUrl}${RateTableAPIMethod.postRateTableDetail}`;
    return this._httpService
      .post(rateTableUrl, rateTableRequest, this.geRateTableHttpOptions())
      .pipe(catchError((e: any) => this.handleError(e, this)));
  }
  getExistingGroupDetails(groupId: number): any {
    let existingGroupUrl = `${this.censusLiteApiBaseUrl}${CensusLiteMethod.GetExistingGroup}`;
    existingGroupUrl = existingGroupUrl.replace("{id}", groupId.toString());
    return this._httpService
      .get<any>(existingGroupUrl, this.getQuoteLiteHttpOptions())
      .pipe(catchError((e: any) => this.handleError(e, this)));
  }
  generateRateTables(d): any {
    let rateTableUrl = `${this.baseUrl}${RateTableAPIMethod.postRateTableGenerate}`;
    return this._httpService
      .post(rateTableUrl, d, this.geRateTableHttpOptions())
      .pipe(catchError((e: any) => this.handleError(e, this)));
  }

  getDownloadPDFURL(Id: number): string {
    let rateTableUrl = `${this.baseUrl}${RateTableAPIMethod.postDownloadPDFRateTableGenerate}`;
    rateTableUrl = rateTableUrl.replace("{Id}", Id.toString());
    return rateTableUrl;
  }

  getDownloadExcelURL(Id: number): string {
    let rateTableUrl = `${this.baseUrl}${RateTableAPIMethod.postDownloadExcelRateTableGenerate}`;
    rateTableUrl = rateTableUrl.replace("{Id}", Id.toString());
    return rateTableUrl;
  }

  startDownloads(downloads: Download[]): Observable<any> {
    this.downloads = downloads;
    this.downloads.forEach((item, index) => {
      item.responseObservable = this.downloadFile(item.url, index);
    });
    const res: Observable<any>[] = this.downloads.map(
      (a) => a.responseObservable
    );
    return forkJoin(res);
  }

  downloadFile(downloadUrl: string, index: number) {
    this.generatingRateTable = true;
    const observable = new Observable((observer: Observer<any>) => {
      this._httpService
        .get(downloadUrl, this.getdownloadHttpOptions())
        .subscribe(
          (event) => {
            if (event.type === HttpEventType.DownloadProgress) {
              const percent = Math.round(100 * (event.loaded / event.total));
              this.downloads[index].percent = percent;
              const msg =
                this.downloads[index].url +
                " percent: " +
                percent.toString() +
                " for file: " +
                this.downloads[index].fileName +
                " length: " +
                event.loaded +
                "/" +
                event.total;
              observer.next(msg);
            } else if (event.type === HttpEventType.Response) {
              this.downloads[index].responseData = event.body;
              this.saveFileAs(this.downloads[index]);
              observer.complete();
            }
          },
          (err: any) => {
            // console.log('Error:', err);
          }
        );
    });
    return observable;
  }

  saveFileAs(download) {
    const blob = new Blob([download.responseData], { type: download.mime });

    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(blob, download.fileName);
      return;
    }
    saveAs(blob, download.fileName);
  }

  getValueFromLocalstorage(localStorageName: string) {
    let value: string = localStorage.getItem(localStorageName);
    if (value == undefined || value == null) {
      return "";
    }
    return value;
  }

  isFromBrokerMobileApp() {
    return Number(this.getValueFromLocalstorage("isBma")) === 1;
  }
  redirectToQuoteLiteUrl() {
    return this.wbQuoteLiteUrl;
  }
  //Get value from QueryString
  getValueFromRoute(route: ActivatedRoute, param: string): string {
    let value: string;
    route.params
      .map((params) => params[param])
      .subscribe((result) => {
        value = result;
        this.rateTableId.next(result);
      });
    return value;
  }
  private handleError(error: HttpErrorResponse, self) {
    let errorMessage, errorStatusCode;
    if (error.status === 401) {
      self.displayAlertPopUp();
      setTimeout(() => {
        window.location.href = this.ratesTable;
      }, 3000);
      return throwError(
        "User session has expired. You'll be redirected back to NHWS in few seconds."
      );
    } else if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      errorMessage = error.error.message;
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      errorMessage =
        `Backend returned code ${error.status}, ` +
        `body was: ${error.message}`;
    }
    errorStatusCode = error.status;
    console.error(errorMessage);
    self.displayAlertPopUp(errorMessage);
    self.spinner.hide();
  }
  displayAlertPopUp(errorMessage) {
    this.dialog.open(AlertPopupComponent, {
      width: "250px",
      autoFocus: false,
      data: {
        title: "Error",
        Message: ValidationMessage.ServerError + errorMessage,
        showCancelButton: true,
      },
    });
  }
  getPackagePlan(quotingContext) {
    let getCarriersUrl = `${environment.apiEndPoints.nqsPlanApiBaseUri}${NQSPlanApiMethod.GetPackagePlanRates}`;
    return this._httpService.post<any>(
      getCarriersUrl,
      quotingContext,
      this.nqsHttpOptions
    );
  }

  getQuotableDates(stateId: number): any {
    let quotableDatesUrl = `${this.planLiteApiBaseUrl}${PlanLiteMethod.QuotableDates}`;
    quotableDatesUrl = quotableDatesUrl.replace(
      "{stateId}",
      stateId.toString()
    );
    return this._httpService.get<any>(
      quotableDatesUrl,
      this.getQuoteLiteHttpOptions()
    );
  }
 

  getRateTableUAHttpOptions() {
    return {
      headers: new HttpHeaders({
        "Cache-Control": "no-cache",
        Pragma: "no-cache",
        "Content-Type": "application/json",
        userAgent: window.navigator.userAgent,
        Authorization: `Bearer ${this.authService.authToken}`,
      }),
    };
  }

  getSupportedBrowsers(): any {
    let rateTableUrl = `${this.baseUrl}${RateTableAPIMethod.getSupportedBrowsers}`;
    return this._httpService
      .get(rateTableUrl, this.getRateTableUAHttpOptions())
      .pipe(catchError((e: any) => this.handleError(e, this)));
  }

  getCarrierLogoDetails(carrierLogoRequest): any {
    let getCarrierLogoUrl = `${this.planLiteApiBaseUrl}${PlanLiteMethod.GetCarrierLogos}`;
    return this._httpService.post<any>(
      getCarrierLogoUrl,
      carrierLogoRequest,
      this.getQuoteLiteHttpOptions()
    );
  }
  getCarrierLogoFilePath(logoPath): any {
    let url = `${this.planLiteApiBaseUrl}${PlanLiteMethod.LogoFilePath}`;
    url = url.replace("{*filePath}", logoPath.toString());
    return this._httpService.get<any>(url, {
      responseType: "image/svg+xml; charset=utf-8",
    });
  }
  getBrokerLicensedStates(brokers: any[]): string {
    const stateSet = new Set<number>();
    brokers.forEach(broker => {
      broker.BrokerLicenses?.forEach((license: any) => {
        if (license?.StateId) {
          stateSet.add(license.StateId);
        }
      });
    });
  
    return Array.from(stateSet).join(',');
  }  
}
